import { render, staticRenderFns } from "./Roster.vue?vue&type=template&id=3b02fb3e"
import script from "./Roster.vue?vue&type=script&lang=js"
export * from "./Roster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports